<template>
  <!-- 移动端 -->
  <div class="mobileTerminal maxWidth">
    <div
      class="mobileTerminal-bannner"
      :style="'background-image:url(' + bannerImg + ')'"
    >
      <div class="mobileTerminal-bannnerBox">
        <span class="edescription">{{ bannerList.alias }}</span>
        <span class="name">{{ bannerList.name }}</span>
        <span class="description">{{ bannerList.description }}</span>
        <button type="button" @click="clickParent">立即咨询</button>
      </div>
    </div>
    <NavAssembly :navList="navList" />
    <!-- 系统类型 -->
    <div class="systemType" id="systemType">
      <div class="systemType-top">
        <span
          >{{ typeList.name }}<img src="../../assets/bigTy.png" alt=""
        /></span>
      </div>
      <div class="systemType-main">
        <div class="systemType-pic">
          <img :src="typeList.img" alt="" />
        </div>
        <div class="systemType-mainTop">
          <div class="systemType-mainTopLeft">
            <div class="mainTopLeftBox">
              <span>{{ typeList.description }}</span>
              <div class="">
                <span>{{ typeList.keywords }}</span>
              </div>
            </div>
            <p>{{ typeList.details }}</p>
          </div>
          <div class="systemType-mainTopRight">
            <button type="button" @click="clickParent">立即咨询</button>
          </div>
        </div>
        <div class="systemType-mainList">
          <div
            class="systemType-mainListBox"
            v-for="(item, index) in typeList.lists"
            :key="index"
          >
            <span>{{ item.name }}</span>
            <div class="titleBox">
              <span>{{ item.keywords }}</span>
            </div>
            <p :title="item.description">{{ item.description }}</p>
            <div class="picBox" v-if="index == 0">
              <img :src="item.icon1" alt="" />
              <img :src="item.icon2" alt="" />
            </div>
            <div class="picBox" v-else>
              <img :src="item.icon" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 建设意义 -->
    <div class="businessManagement" id="constructionMeaning">
      <div class="businessManagement-top">
        <img src="../../assets/bigTy1.png" alt="" />
        <span>{{ businessManagementList.name }}</span>
        <p>{{ businessManagementList.description }}</p>
      </div>
      <div class="businessManagement-main">
        <div
          class="businessManagement-mainBox"
          v-for="(item, index) in businessManagementList.lists"
          :key="index"
        >
          <div class="businessManagement-number">
            <img :src="item.num_img" alt="" />
          </div>
          <img :src="item.icon" alt="" />
          <span>{{ item.name }}</span>
          <p>
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
    <!-- 核心产品 -->
    <div class="coreProducts" id="coreProduct">
      <div class="coreProducts-top">
        <img src="../../assets/bigTy.png" alt="" />
        <span>{{ coreProductsList.name }}</span>
      </div>
      <div class="coreProducts-mian">
        <div class="coreProducts-mianLeft">
          <div
            class="coreProducts-mianLeftBox"
            v-for="(item, index) in coreProductsList.lists"
            :key="index"
            :class="{ titleActive: titleShow == index }"
            @click="titleCilck(index)"
          >
            <span>{{ item.name }}</span>
            <img src="../../assets/jiantou1.png" alt="" />
          </div>
        </div>
        <div class="coreProducts-mianRight">
          <div
            class=""
            v-for="(item, index) in coreProductsList.lists"
            :key="index"
          >
            <div class="coreProducts-mianRightBox" v-if="titleShow == index">
              <div class="coreProducts-mianRightBoxLeft">
                <div class="mianRightBoxLeft-top">
                  <span>{{ item.name }}</span>
                  <p>
                    {{ item.description }}
                  </p>
                </div>
                <div class="mianRightBoxLeft-bottom">
                  <span>核心功能:</span>
                  <div class="mianRightBoxLeft-bottomBox">
                    <div
                      class="mianRightBoxLeft-bottomBoxItem"
                      v-for="(itemText, indexText) in item.list"
                      :key="indexText"
                    >
                      <div class="bottomBoxItem-dain"></div>
                      <span>{{ itemText }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="coreProducts-mianRightBoxRight">
                <img :src="item.img" alt="" />
                <button type="button" @click="clickParent">立即咨询</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 行业方案 -->
    <div class="industryScheme" id="industrySolution">
      <div class="industryScheme-top">
        <img src="../../assets/bigTy.png" alt="" />
        <span>{{ bannerBoxListBox.name }}</span>
        <p>{{ bannerBoxListBox.description }}</p>
      </div>
      <div class="industryScheme-main">
        <button
          type="button"
          class="el-carousel__arrow el-carousel__arrow--left"
          @click="prev"
        >
          <i class="el-icon-arrow-left"></i></button
        ><button
          type="button"
          class="el-carousel__arrow el-carousel__arrow--right"
          @click="next"
        >
          <i class="el-icon-arrow-right"></i>
        </button>
        <el-carousel
          indicator-position="outside"
          arrow="never"
          :autoplay="false"
          ref="swiper"
        >
          <el-carousel-item v-for="item in bannerBoxCount" :key="item">
            <div class="bannerBoxInner">
              <div
                class="bannerBox"
                v-for="(it, i) in bannerBoxListBox.lists"
                :key="i"
                v-show="i >= (item - 1) * 4 && i < item * 4"
              >
                <div class="bannerBox-top">
                  <div class="bannerBox-topPic">
                    <img :src="it.icon" alt="" />
                  </div>
                  <span>{{ it.name }}</span>
                </div>
                <div class="bannerBox-bottom">
                  <div
                    class="bannerBox-bottomBox"
                    v-for="(itemText, indexText) in it.lists"
                    :key="indexText"
                  >
                    <div class="bottomBox-dian"></div>
                    <span>{{ itemText }}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <ChooseUs :chooseUsList="chooseUsList" />
    <CommonProblem :commonProblemList="commonProblemList" />
    <DeliveryList :deliveryList="deliveryList" />
    <DevelopmentProcess :developmentProcessList="developmentProcessList" />
    <ZXDialog ref="mychild" />
  </div>
</template>

<script>
import NavAssembly from "../../components/NavAssembly.vue";
import ChooseUs from "../../components/ChooseUs.vue";
import CommonProblem from "../../components/CommonProblem.vue";
import DeliveryList from "../../components/DeliveryList.vue";
import DevelopmentProcess from "../../components/DevelopmentProcess.vue";
import ZXDialog from "../../components/ZXDialog.vue";
export default {
  name: "mobileTerminal",
  components: {
    NavAssembly,
    ChooseUs,
    CommonProblem,
    DeliveryList,
    DevelopmentProcess,
    ZXDialog
  },
  metaInfo() {
    //设置浏览器标签页标题
    return {
      meta: [
        {
          name: "description",
          content: this.description
        }
      ]
    };
  },
  data() {
    return {
      description: "",
      titleShow: 0,
      bannerList: {},
      coreProductsList: {},
      businessManagementList: {},
      bannerBoxListBox: {},
      commonProblemList: {},
      chooseUsList: {},
      deliveryList: {},
      developmentProcessList: {},
      navList: [],
      typeList: {},
      bannerBoxCount: 0,
      bannerImg: ""
    };
  },
  mounted() {
    // console.log(this.bannerBoxCount);
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios.get("index/common/getMobileSystem").then(res => {
        // console.log(res);
        if (res.status == 200) {
          this.description = res.data.data.description;
          this.bannerList = res.data.data["01"];
          this.bannerImg = res.data.data["01"].banner[0].pic;
          this.navList = res.data.data["02"];
          this.typeList = res.data.data["03"];
          this.businessManagementList = res.data.data["04"];
          this.coreProductsList = res.data.data["05"];
          this.bannerBoxListBox = res.data.data["06"];
          this.bannerBoxCount = Math.ceil(res.data.data["06"].lists.length / 4);
          this.chooseUsList = res.data.data["07"];
          this.commonProblemList = res.data.data["08"];
          this.deliveryList = res.data.data["09"];
          this.developmentProcessList = res.data.data["010"];
        }
      });
    },
    titleCilck(index) {
      this.titleShow = index;
    },
    prev() {
      this.$refs.swiper.prev();
    },
    next() {
      this.$refs.swiper.next();
    },
    clickParent() {
      this.$refs.mychild.parentHandleclick();
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.mobileTerminal {
  width: 1920px;
  margin: 0 auto;
  margin-top: 70px;
}
.mobileTerminal-bannner {
  height: 737px;
  background-repeat: no-repeat;
  /* background-size: 100%; */
  position: relative;
}
.mobileTerminal-bannnerBox {
  position: absolute;
  top: 149px;
  left: 311px;
  display: flex;
  flex-direction: column;
}
.mobileTerminal-bannnerBox .edescription {
  font-size: 66px;
  font-family: DIN BlackAlternate;
  font-weight: 600;
  color: rgba(69, 70, 71, 0.3);
  line-height: 76px;
  display: block;
  margin-bottom: 74px;
}
.mobileTerminal-bannnerBox .name {
  font-size: 50px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  display: block;
  margin-bottom: 21px;
}
.mobileTerminal-bannnerBox .description {
  width: 518px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.7);
  line-height: 28px;
  display: block;
  margin-bottom: 100px;
}
.mobileTerminal-bannnerBox button {
  cursor: pointer;
  width: 210px;
  height: 54px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  border-radius: 6px 0px 6px 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.mobileTerminal-nav {
  height: 70px;
  background: #ffffff;
  box-shadow: 0px 6px 14px 0px rgba(89, 98, 107, 0.08);
}
/* 系统类型 */
#systemType {
  position: relative;
  margin-top: 72px;
}
.systemType-top {
  text-align: center;
  margin-bottom: 59px;
}
.systemType-top span {
  position: relative;
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.systemType-top span img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -7px;
  left: -7%;
}
.systemType-main {
  height: 500px;
  background: #f6fafb;
  border: 1px solid #ffffff;
  padding-top: 37px;
  position: relative;
}
.systemType-pic {
  position: absolute;
  top: 109px;
  left: 31px;
}
.systemType-pic img {
  display: block;
  width: 420;
  height: 282px;
}
.picBox {
  display: flex;
}
.picBox img {
  margin-right: 28px;
}
.systemType-mainTop {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  /* text-align: center; */
  align-items: center;
  margin-bottom: 39px;
}
.systemType-mainTopLeft {
  display: flex;
  flex-direction: column;
}

.systemType-mainTopLeft > p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #595959;
}
.mainTopLeftBox {
  display: flex;
  align-items: center;
  margin-bottom: 17px;
}
.mainTopLeftBox > span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #00000c;
}
.mainTopLeftBox > div {
  width: 198px;
  height: 22px;
  background: rgba(255, 66, 66, 0.1);
  border: 1px solid #ff4242;
  border-radius: 6px 0px 6px 0px;
  line-height: 17px;
  text-align: center;
}
.mainTopLeftBox > div span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ff4242;
}
.systemType-mainTopRight button {
  width: 100px;
  height: 34px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.systemType-mainList {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.systemType-mainListBox {
  width: 305px;
  height: 234px;
  background: #ffffff;
  border: 1px solid #e5e9ea;
  padding: 27px 21px 20px;
  position: relative;
  z-index: 999;
}
.systemType-mainListBox > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.systemType-mainListBox > .titleBox {
  width: fit-content;
  white-space: nowrap;
  padding: 0 5px;
  height: 20px;
  background: rgba(255, 66, 66, 0.1);
  text-align: center;
  line-height: 18px;
  margin-top: 13px;
  margin-bottom: 26px;
}
.systemType-mainListBox > div > span {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ff4242;
}
.systemType-mainListBox > p {
  width: 261px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  line-height: 24px;
  margin-bottom: 10px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.systemType-mainListBox > img {
  display: block;
  height: 26px;
}
/* 建设意义 */
.businessManagement-top {
  height: 300px;
  background-image: url("~../../assets/YJ-banner.png");
  background-repeat: no-repeat;
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  position: relative;
  text-align: center;
  padding-top: 94px;
  margin-bottom: 110px;
}
.businessManagement-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: 616px;
  top: 87px;
}
.businessManagement-top span {
  display: block;
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 24px;
}
.businessManagement-top p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}
.businessManagement-main {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
}
.businessManagement-mainBox {
  width: 350px;
  height: 190px;
  padding-top: 31px;
  margin-right: 76px;
  margin-bottom: 90px;
  position: relative;
}
.businessManagement-mainBox img {
  display: block;
  width: 40px;
  height: 40px;
  margin-bottom: 16px;
}
.businessManagement-mainBox span {
  display: block;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  margin-bottom: 28px;
}
.businessManagement-mainBox p {
  width: 340px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
}
.businessManagement-number {
  position: absolute;
  top: 0;
  right: 0;
  z-index: -1;
}
.businessManagement-number img {
  display: block;
  width: 153px;
  height: 190px;
}

/* 核心产品 */
.coreProducts {
  height: 622px;
  background-image: url("~../../assets/coreProducts-banner.png");
  background-repeat: no-repeat;
  position: relative;
  padding-top: 46px;
}
.coreProducts-top {
  text-align: center;
  position: relative;
  margin-bottom: 56px;
}
.coreProducts-top span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.coreProducts-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: 796px;
  top: -14px;
}
.coreProducts-mian {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  position: relative;
}
.coreProducts-mianLeft {
  width: 280px;
  height: 460px;
  padding: 20px 0 54px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.7),
    rgba(255, 255, 255, 0.1)
  );
  z-index: 9;
}
.coreProducts-mianLeftBox {
  width: 280px;
  height: 84px;
  display: flex;
  justify-content: space-between;
  padding: 0 23px 0 49px;
  cursor: pointer;
  align-items: center;
}

.coreProducts-mianLeftBox img {
  display: block;
  width: 16px;
  height: 20px;
  display: none;
}
.coreProducts-mianLeftBox span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #454647;
}
.titleActive {
  z-index: 9;
  background: linear-gradient(90deg, #dc3939, #ff4242);
  box-shadow: 0px 8px 10px 0px rgba(253, 66, 66, 0.2);
  border-radius: 0px 6px 0px 0px;
  align-items: center;
}
.titleActive span {
  color: #ffffff;
}
.titleActive img {
  display: block;
}
.coreProducts-mianRight {
  /* width: 1060px; */
  height: 460px;
  position: relative;
  left: -60px;
  background: #ffffff;
  padding-top: 57px;
  padding-left: 110px;
}
.coreProducts-mianRightBox {
  display: flex;
}
.mianRightBoxLeft-top {
  display: flex;
  flex-direction: column;
  margin-bottom: 76px;
}
.mianRightBoxLeft-top span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 24px;
}
.mianRightBoxLeft-top p {
  width: 393px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
}
.mianRightBoxLeft-bottom > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 33px;
}
.mianRightBoxLeft-bottomBoxItem {
  display: flex;
  align-items: center;
  padding-left: 11px;
  margin-bottom: 21px;
}
.mianRightBoxLeft-bottomBoxItem .bottomBoxItem-dain {
  width: 6px;
  height: 6px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  border-radius: 0px 3px 0px 3px;
  margin-right: 11px;
}
.mianRightBoxLeft-bottomBoxItem > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  white-space: nowrap;
}
.coreProducts-mianRightBoxRight {
  display: flex;
  flex-direction: column;
  padding-right: 58px;
  margin-left: 52px;
}
.coreProducts-mianRightBoxRight img {
  display: block;
  width: 446px;
  height: 281px;
  margin-bottom: 44px;
}
.coreProducts-mianRightBoxRight button {
  margin: 0 auto;
  width: 100px;
  height: 34px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  border-radius: 6px 0px 6px 0px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
/* 行业方案 */
.industryScheme {
  padding-top: 104px;
}
.industryScheme-top {
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  margin-bottom: 149px;
}
.industryScheme-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -14px;
  left: 792px;
}
.industryScheme-top span {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  display: block;
  margin-bottom: 14px;
}
.industryScheme-top p {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
}
.industryScheme-main {
  width: 1280px;
  margin: 0 auto;
  border-top: 1px solid rgba(214, 219, 221, 0.4);
  position: relative;
  padding: 0 70px;
}
.industryScheme-main .el-carousel {
  position: relative;
  top: -30px;
}
#industrySolution .industryScheme-main .bannerBox {
  display: flex;
  flex-direction: column;
  width: 180px;
  margin-right: 119px;
  text-align: center;
}
#industrySolution .industryScheme-main .bannerBox:nth-child(4n) {
  margin-right: 0;
}
#industrySolution .industryScheme-main .bannerBoxInner {
  display: flex;
  /* justify-content: space-between; */
}
.bannerBox-top {
  display: flex;
  flex-direction: column;
  margin-bottom: 43px;
}
.bannerBox-top > span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.bannerBox-topPic {
  margin: 3px auto 29px;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border: 1px solid rgba(255, 66, 66, 0.3);
  box-shadow: 0px 0px 10px rgba(255, 66, 66, 0.3);
  border-radius: 25px;
}
.bannerBox-topPic img {
  margin: 0 auto;
  padding-top: 15px;
  display: block;
  width: 32px;
  /* height: 30px; */
}
.bannerBox-bottom {
  display: flex;
  flex-wrap: wrap;
  width: 180px;
}
.bannerBox-bottom .bannerBox-bottomBox {
  display: flex;
  margin-right: 22px;
  margin-bottom: 19px;
  align-items: center;
}
.bannerBox-bottom .bannerBox-bottomBox:nth-child(2n) {
  margin-right: 0;
}

.bannerBox-bottomBox > span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
}
.bannerBox-bottom .bottomBox-dian {
  width: 6px;
  height: 6px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  border-radius: 0px 3px 0px 3px;
  margin-right: 10px;
}
.industryScheme-main >>> .el-icon-arrow-left:before {
  display: block;
  content: " ";
  background-image: url("~../../assets/jt-left.png");
  background-size: contain;
  width: 16px;
  height: 20px;
  background-repeat: no-repeat;
}
.industryScheme-main >>> .el-carousel__arrow--left {
  left: -75px;
  top: 0;
}
.industryScheme-main >>> .el-carousel__arrow--right {
  top: 0;
  right: -75px;
}

.industryScheme-main >>> .el-icon-arrow-right:before {
  display: block;
  content: " ";
  background-image: url("~../../assets/jt-right.png");
  background-size: contain;
  width: 16px;
  height: 20px;
  background-repeat: no-repeat;
}
.industryScheme-main .el-carousel__arrow {
  background: #c9ced2;
  align-items: center;
}
.industryScheme-main .el-carousel__arrow:hover {
  background: linear-gradient(0deg, #dc3939, #ff4242);
}
.industryScheme-main >>> .el-carousel__button {
  width: 100px;
  height: 3px;
  background: #df3a3a;
}
</style>



// WEBPACK FOOTER //
// src/views/productIntroduction/MobileTerminal.vue